export class ApiError extends Error {
  constructor(message) {
    super(message);
    //this.name = 'ApiError'; Displayed in alert messages before all ApiErrors ie 401, 406, etc. see api.js line
  }
}
